import { lazyLoad } from 'utils/loadable';

export const EconomyActivity = lazyLoad(
  () => import('./economyActivity.page'),
  (module) => module.EconomyActivity
);
